import apiClient from '../utils/apiClient';

class AuthService {
    // User registration
    async register(userData) {
        const response = await apiClient.post('/auth/register', userData);
        return response;
    }

    // User signup
    async signup(userData) {
        const response = await apiClient.post('/signup', userData);

        // Set auth token in API client
        if (response.data && response.data.token) {
            apiClient.setAuthToken(response.data.token);
        }

        return response;
    }

    // User login
    async login(credentials) {
        const response = await apiClient.post('/login', credentials);

        // Set auth token in API client
        if (response.data && response.data.token) {
            apiClient.setAuthToken(response.data.token);
        }

        return response;
    }

    // User logout
    async logout() {
        try {
            await apiClient.post('/auth/logout');
        } catch (error) {
            // Even if logout fails on server, clear local token
            console.warn('Logout request failed:', error);
        } finally {
            // Always clear local token
            apiClient.removeAuthToken();
        }
    }

    // Get current user profile
    async getProfile() {
        const response = await apiClient.get('/auth/profile');
        return response;
    }

    // Update user profile
    async updateProfile(userData) {
        const response = await apiClient.put('/auth/profile', userData);
        return response;
    }

    // Change password
    async changePassword(passwordData) {
        const response = await apiClient.post('/auth/change-password', passwordData);
        return response;
    }

    // Forgot password recovery
    async sendForgotPasswordOtp(loginId) {
        const response = await apiClient.post('/auth/forgot-password/send', { loginId });
        return response;
    }

    async verifyForgotPasswordOtp(loginId, otp) {
        const response = await apiClient.post('/auth/forgot-password/verify', { loginId, otp });
        return response;
    }

    async resetPasswordWithToken(resetToken, newPassword) {
        const response = await apiClient.post('/auth/forgot-password/reset', {
            resetToken,
            newPassword,
        });
        return response;
    }

    // Forgot login ID recovery (owners)
    async sendForgotLoginIdOtp(phoneNumber) {
        const response = await apiClient.post('/auth/forgot-login-id/send', { phoneNumber });
        return response;
    }

    async verifyForgotLoginIdOtp(phoneNumber, otp) {
        const response = await apiClient.post('/auth/forgot-login-id/verify', { phoneNumber, otp });
        return response;
    }
}

const authService = new AuthService();
export default authService;
